import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";

export const editWarehouse = createAsyncThunk("warehouse/editWarehouse", async ({ id, data }, { rejectWithValue }) => {
	try {
		const response = await axiosHttp.patch(`warehouse/${id}`, data);
		return response.data;
	} catch (err) {
		if (!err.response) {
			throw err;
		}
		return rejectWithValue(err.response.data);
	}
});

const initialState = {
	isLoading: false,
	isError: false,
	error: null,
	data: null,
	message: null,
};

const EditWarehouseSlice = createSlice({
	name: "EditWarehouseSlice",
	initialState,
	reducers: {
		resetEditWarehouseState: (state) => {
			state.isLoading = false;
			state.isError = false;
			state.error = null;
			state.data = null;
			state.message = null;
		},
	},
	extraReducers: (builder) => {
		builder.addCase(editWarehouse.pending, (state) => {
			state.isLoading = true;
			state.isError = false;
			state.message = null;
		});

		builder.addCase(editWarehouse.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isError = false;
			state.data = action.payload.data;
			state.message = action.payload.message || null;
		});

		builder.addCase(editWarehouse.rejected, (state, action) => {
			state.isLoading = false;
			state.isError = true;
			state.error = action.payload;
			state.message = action.payload?.message || null;
		});
	},
});

export const { resetEditWarehouseState } = EditWarehouseSlice.actions;
export default EditWarehouseSlice.reducer;
